import { createBrowserHistory } from "history";
// import ga from "./ga"; remove temporarily

const history = createBrowserHistory();

export default history;
